export const formatDate = (
  dateString?: string,
  locale: string = 'en-US',
): string =>
  dateString
    ? new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(
        new Date(dateString),
      )
    : '';
